import React from 'react';

import { HeaderBar, HeaderWrapper, Title } from '@pkg/components/PageHeaderTitle/styles';

interface PageHeaderProps {
    title: string;
    unfixedHeight?: boolean;
    headerAction?: React.ReactNode;
}
export const PageHeaderTitle = ({ title, headerAction, unfixedHeight = false }: PageHeaderProps) => {
    return (
        <HeaderWrapper $unfixedHeight={unfixedHeight}>
            <HeaderBar>
                <Title>{title}</Title>
                {headerAction}
            </HeaderBar>
        </HeaderWrapper>
    );
};
